module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Legion-S2.5c4d9ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Legion-S2.jpg
// module id = 7Kk6
// module chunks = 0